export default {"src":"/_next/static/media/working-capital.eb02be55.svg","height":38,"width":41};